module.exports = __webpack_public_path__ + "static/apollo-ae302b24ca67725d9bb67ce971fda23a.png";